export default {
  'delegationConfigurations.title': 'Gestionar Configuraciones Delegación',

  'delegationConfigurations.form.environment': 'Entorno',
  'delegationConfigurations.form.process': 'Proceso',
  'delegationConfigurations.form.name': 'Usuario delegado',
};
